<div class="row">
  <div class="col-md-12">
    <br>
    <div class="titulo">
        Mantenedor de Configuración IVirtual
    </div>
  </div>

  <div *ngIf="isLoading" class="text-center my-4">
    <div class="loader">
      <div class="loader__figure"></div>
      <p class="loader__label">Medis</p>
    </div>
  </div>

  <div *ngIf="isLoading == false" class="col-md-12">
    <br>
    <table class="table table-bordered">
      <thead style="font-family: Mulish; font-style: normal; font-weight: bold; font-size: 20px; color: #171994; text-align: center; background-color: #e6f0ff;">
        <tr>
          <th>#</th>
          <th>Cliente</th>
          <th>Imagen</th>
          <th>Puede usar IVirtual</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody *ngIf="ivirtualClientList.length != 0" style="background-color: white; font-family: Mulish; font-size: 16px; color: #3F3F3F; text-align: center;">
        <tr class="ng-star-inserted" *ngFor="let item of ivirtualClientList">
          <td>{{item.cus_id}}</td>
          <td>{{item.cus_name}}</td>
          <td><img src="{{item.cus_url_image_web}}" alt="" style="width: 50%;"></td>
          <td>{{item.cus_can_ivirtual ? 'Si' : 'No'}}</td>
          <td>
            <div class="row justify-content-center m-0">
              <div class="col-12 p-0">
                <span data-toggle="modal" data-target="#modalVitalsConfig" style="cursor: pointer;" (click)="getConfigClient(item.cus_id)">
                  <mat-icon role="img" class="mat-icon notranslate material-icons mat-icon-no-color" 
                      style="color: #316AD8;" aria-hidden="true" data-mat-icon-type="font">manage_search
                  </mat-icon>
                </span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="ivirtualClientList.length == 0" style="background-color: white; font-family: Mulish; font-size: 16px; color: #3F3F3F; text-align: center;">
        <tr>
          <td colspan="5">No se encontraron registros</td>
        </tr>
      </tbody>
    </table>
  </div>

</div>


<!-- modal Visualizar/Editar-->
<div class="modal fade" id="modalVitalsConfig" tabindex="-1" role="dialog" aria-labelledby="modalVitalsConfigTitle" aria-hidden="true">

  <div class="modal-dialog modal-lg" role="document">    
    <div class="modal-content">

      <div *ngIf="isLoadingModal" class="modal-body">
        <div class="loader">
          <div class="loader__figure"></div>
          <p class="loader__label">Medis</p>
        </div>
      </div>      

      <!-- Body -->
      <div *ngIf="isLoadingModal == false" class="modal-body" >
        <div class="border rounded p-3">

          <!-- Título + Select all en la MISMA fila -->
          <div class="d-flex align-items-center justify-content-between mb-3">
            <p class="tituloModal mb-0" style="width:auto;">Variables a calcular</p>

            <div class="d-flex align-items-center">
              <div class="form-check m-0 mr-3">
                <input
                  id="svcEnabled"
                  class="form-check-input"
                  type="checkbox"
                  [(ngModel)]="isActive">
                <label class="form-check-label" for="svcEnabled">
                  {{ isActive ? 'Activo' : 'Desactivado' }}
                </label>
              </div>
            </div>

            <div class="form-check m-0">
              <input id="selectAll" class="form-check-input" type="checkbox" [(ngModel)]="toggleSelected" (change)="toggleAll(toggleSelected)" disabled>
              <label class="form-check-label" for="selectAll">Seleccionar todo</label>
            </div>
          </div>

          <hr class="mt-2 mb-4"/>

          <div class="row">
            <!-- Medical data -->
            <div class="col-md-4 mb-4">
              <div class="d-flex align-items-center mb-2">
                <span class="mr-2" aria-hidden="true">🩺</span>
                <strong class="mb-0">Datos Medicos</strong>
              </div>

              <div class="form-check mb-2">
                <input id="heartRate" class="form-check-input" type="checkbox" [(ngModel)]="checkHeartRate" />
                <label class="form-check-label" for="heartRate">Frecuencia cardíaca</label>
              </div>

              <div class="form-check mb-2">
                <input id="respiratoryRate" class="form-check-input" type="checkbox" [(ngModel)]="checkRespiratoryRate" />
                <label class="form-check-label" for="respiratoryRate">Frecuencia respiratoria</label>
              </div>
            </div>

            <!-- Well-being data -->
            <div class="col-md-4 mb-4">
              <div class="d-flex align-items-center mb-2">
                <span class="mr-2" aria-hidden="true">⏱️</span>
                <strong class="mb-0">Datos de bienestar</strong>
              </div>

              <div class="form-check mb-2">
                <input id="hbpRisk" class="form-check-input" type="checkbox" [(ngModel)]="checkHbpRisk" disabled />
                <label class="form-check-label" for="hbpRisk">Riesgo de hipertensión</label>
              </div>

              <div class="form-check mb-2">
                <input id="hrv" class="form-check-input" type="checkbox" [(ngModel)]="checkHrv" disabled />
                <label class="form-check-label" for="hrv">Variabilidad de la frecuencia cardíaca</label>
              </div>

              <div class="form-check mb-2">
                <input id="stressLevel" class="form-check-input" type="checkbox" [(ngModel)]="checkStressLevel" disabled />
                <label class="form-check-label" for="stressLevel">Nivel de estrés</label>
              </div>

              <div class="form-check mb-2">
                <input id="visualAge" class="form-check-input" type="checkbox" [(ngModel)]="checkVisualAge" disabled />
                <label class="form-check-label" for="visualAge">Edad visual</label>
              </div>

              <div class="form-check mb-2">
                <input id="bmiFace" class="form-check-input" type="checkbox" [(ngModel)]="checkBmiFace" disabled />
                <label class="form-check-label" for="bmiFace">IMC estimado a partir del rostro</label>
              </div>
            </div>

            <!-- Other -->
            <div class="col-md-4 mb-4">
              <div class="d-flex align-items-center mb-2">
                <span class="mr-2" aria-hidden="true">📋</span>
                <strong class="mb-0">Otros</strong>
              </div>

              <div class="form-check mb-2">
                <input id="cardioScore" class="form-check-input" type="checkbox" [(ngModel)]="checkCardioScore" disabled />
                <label class="form-check-label" for="cardioScore">Puntaje de salud cardiovascular</label>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Footer -->
      <div *ngIf="isLoadingModal == false" class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="saveConfig()">Guardar</button>
      </div>

    </div>
  </div>
</div>
<!-- modal Visualizar/Editar-->